import React, { useEffect, useState } from "react";
import { apiJson } from "../api/client";

function ClientDashboardPage() {
  const username = localStorage.getItem("username");

  const [summary, setSummary] = useState(null);
  const [devices, setDevices] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const loadClientData = async () => {
      try {
        const [summaryData, devicesData] = await Promise.all([
          apiJson("/client/summary"),
          apiJson("/client/devices"),
        ]);

        if (cancelled) return;

        setSummary(summaryData);
        setDevices(devicesData.devices || []);
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Failed to load client dashboard");
        }
      }
    };

    loadClientData();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const getStatusClass = (status) => {
    if (status === "online") return "status-online";
    if (status === "offline") return "status-offline";
    return "status-unknown";
  };

  return (
    <div className="client-dashboard-page">
      <div className="client-header">
        <div className="client-header-left">
          <div className="client-logo">
            {summary?.company_name?.charAt(0) || "C"}
          </div>

          <div>
            <h1 className="client-company-name">
              {summary?.company_name || "Client Portal"}
            </h1>
            <p className="client-welcome">
              Welcome back, {username || "Client User"}
            </p>
          </div>
        </div>

        <div className="client-header-right">
          <button className="client-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      {error && <div className="client-error-box">{error}</div>}

      {summary && (
        <>
          <section className="client-hero-card">
            <div>
              <h2>{summary.company_name || "Company"} Overview</h2>
              <p>
                Track your managed devices, review status visibility, and stay
                informed about your environment from one place.
              </p>
            </div>
            <div className="client-company-badge">
              {summary?.company_name || `Company ID: ${summary.company_id}`}
            </div>
          </section>

          <section className="client-summary-grid">
            <div className="client-summary-card">
              <p className="client-summary-label">Total Devices</p>
              <h3>{summary.total_devices}</h3>
            </div>

            <div className="client-summary-card online">
              <p className="client-summary-label">Online Devices</p>
              <h3>{summary.online_devices}</h3>
            </div>

            <div className="client-summary-card offline">
              <p className="client-summary-label">Offline Devices</p>
              <h3>{summary.offline_devices}</h3>
            </div>
          </section>
        </>
      )}

      <section className="client-devices-card">
        <div className="client-section-header">
          <div>
            <h2>My Devices</h2>
            <p>Devices currently assigned to your organization.</p>
          </div>
        </div>

        <div className="client-table-wrap">
          <table className="client-device-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Device Name</th>
                <th>Status</th>
                <th>Company ID</th>
              </tr>
            </thead>
            <tbody>
              {devices.length > 0 ? (
                devices.map((device) => (
                  <tr key={device.id}>
                    <td>{device.id}</td>
                    <td>{device.hostname || device.device_uuid || "Unnamed Device"}</td>
                    <td>
                      <span className={`client-status-badge ${getStatusClass(device.status)}`}>
                        {device.status || "unknown"}
                      </span>
                    </td>
                    <td>{device.company_id}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                    No devices found for this company.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default ClientDashboardPage;